import React, { useState } from "react";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
import { FaCubes } from "react-icons/fa";
import LocationsModal from "./locations-modal";

function LocationsForm({ master, subProduct }) {
  const [showPopup, setShowPopup] = useState(false);
  // console.log(master.subproducts);
  //console.log(subProduct);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          {master.type === "directa" && (
            <table className="table mt-4">
              <thead className="text-center">
                <tr>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Master
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Piezas
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Peso
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Bultos/Locs
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                <tr>
                  <td>{master.number}</td>
                  <td>{master.pzas}</td>
                  <td>{master.weight}</td>
                  <td>
                    <button className="btn" onClick={() => setShowPopup(true)}>
                      <FaCubes />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
          {master.type === "parcial" && (
            <table className="table mt-4">
              <thead className="text-center">
                <tr>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Master
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    House
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Piezas
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Peso
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Bultos/Locs
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                <tr>
                  <td>{master.number}</td>
                  <td></td>
                  <td>{master.pzas}</td>
                  <td>{master.weight}</td>
                  <td></td>
                </tr>
                {master.subproducts.map((sub, index) => (
                  <tr key={index}>
                    <td></td>
                    <td>{sub.hbs}</td>
                    <td>{sub.piezas}</td>
                    <td>{sub.peso}</td>
                    <td>
                      <button
                        className="btn"
                        onClick={() => setShowPopup(true)}
                      >
                        <FaCubes size={20} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      {showPopup && (
        <LocationsModal master={master} onClose={() => setShowPopup(false)} />
      )}
    </>
  );
}

export default LocationsForm;
